
export default function Industries() {
  const industries = [
    {
      icon: 'ri-store-3-line',
      title: 'Importers & Distributors',
      description: 'Streamline your import operations with expert supplier management and cost optimization strategies.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Manufacturers',
      description: 'Secure reliable raw materials and components from Latin America with quality assurance and competitive pricing.'
    },
    {
      icon: 'ri-building-line',
      title: 'Construction Suppliers',
      description: 'Source construction materials and equipment with optimized logistics and favorable commercial terms.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Industrial Buyers',
      description: 'Access industrial supplies and equipment with comprehensive procurement support and cost analysis.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Medical & Specialty Product Distributors',
      description: 'Navigate complex medical and specialty product sourcing with compliance expertise and quality control.'
    }
  ];

  return (
    <section id="industries" className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-orange-600/20 text-orange-400 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Industries We Support
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Trusted Across Multiple Sectors
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Specialized procurement expertise tailored to your industry's unique requirements
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-700 hover:bg-gray-700/50 hover:border-orange-600/50 transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-12 h-12 border-2 border-orange-600 rounded-xl flex items-center justify-center mb-5">
                <i className={`${industry.icon} text-2xl text-orange-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                {industry.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {industry.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
